import React from "react";
import ListTexts from "../organisms/ListTexts";
import { CONTENT_TERMINOS_Y_CONDICIONES } from "../../constants/terminos-y-condiciones";
import "../../assets/styles/ContainerFooterTerminosCondiones.css";

const TerminoYCondiciones = () => {
  return (
    <main style={{ margin: "px 0px" }}>
      <ListTexts array={CONTENT_TERMINOS_Y_CONDICIONES} />
      <div className="container-mainfooter-terminos">
        <span className="text-terminos-uso2">
          RESPONSABLE: Leandro Fabián Lorenzi
        </span>
        <br />
        <span className="text-terminos-uso2">
          Teléfono/Interno: 011 4114-8205/06
        </span>
         <br />
        <span className="text-terminos-uso2">
          Email: leandro.lorenzi@galiciaseguros.com.ar
        </span>
        <br />
        <br />
        <span className="text-terminos-uso2">SUPLENTE: Daniel Iglesias</span>
        <br />
        <span className="text-terminos-uso2">
            Teléfono/Interno: 011 4114-8205/06
        </span>
       
        <br />
        <span className="text-terminos-uso2">
          Email: daniel.iglesias@galiciaseguros.com.ar
        </span>
        <br />
        <span className="text-terminos-uso2">
          Nº DE INSCRIPCIÓN DE LA COMPAÑÍA ANTE LA SSN: 0025
        </span>
        <br />
        <br />
        <span className="text-terminos-uso2">
          En caso de reclamo ante la entidad aseguradora no resuelto o
          desestimado, podrá denunciarlo a través de www.argentina.gob.ar/ssn.
        </span>
      </div>
    </main>
  );
};

export default TerminoYCondiciones;
